export type ArticleSection = {
  heading: string;
  paragraphs: string[];
};

export type Article = {
  id: string;
  title: string;
  summary: string;
  category: string;
  author: string;
  date: string;
  readMinutes: number;
  heat: number;
  cover: string;
  tags: string[];
  content: ArticleSection[];
};

export const categories = [
  { id: 'all', name: '全部话题' },
  { id: 'film', name: '影视现场' },
  { id: 'music', name: '音乐现场' },
  { id: 'show', name: '综艺录制' },
  { id: 'brand', name: '品牌合作' },
  { id: 'fans', name: '粉丝圈层' },
];

export const articles: Article[] = [
  {
    id: 'changye-pianchang-huaxu',
    title: '《长夜引》片场花絮流出，主创深夜对戏引讨论',
    summary:
      '一段片场花絮流出后，「深夜对戏」的片段被反复讨论。有人夸敬业，也有人关注剧组作息，话题热度一路走高。',
    category: '影视现场',
    author: '瓜务组',
    date: '2026-09-10',
    readMinutes: 4,
    heat: 9820,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20set%20at%20night%20with%20warm%20amber%20set%20lights%2C%20silhouettes%20of%20crew%20members%2C%20dramatic%20teal%20and%20orange%20color%20grading%2C%20artistic%20stylized%20illustration%2C%20no%20readable%20text&width=1200&height=800&seq=gualiao-film-01&orientation=landscape',
    tags: ['长夜引', '片场花絮', '深夜对戏'],
    content: [
      {
        heading: '事件是怎么热起来的',
        paragraphs: [
          '今天上午，一段标注为《长夜引》拍摄现场的短视频在多个平台被转发。画面里是夜戏收尾阶段，主演苏辞与陆承筠还在对一段长台词，旁边工作人员在调整灯光。',
          '由于光线昏暗、画面偏手持，视频并没有清晰对白，但「深夜还在抠戏」这个细节被截图传播，短时间内就积累了不小的讨论量。',
        ],
      },
      {
        heading: '网友分成了几种声音',
        paragraphs: [
          '一类声音偏向认可，认为演员愿意为一场戏反复打磨是职业态度；另一类声音则把重点放在剧组作息上，讨论夜戏连拍对工作人员的影响。',
          '也有不少网友保持观望，认为单段花絮信息有限，不足以推断整部剧的拍摄状态，建议等正式物料出来再评价。',
        ],
      },
      {
        heading: '为什么这件事值得关注',
        paragraphs: [
          '《长夜引》是今年关注度较高的古装项目之一，从开机起路透就不断。片场花絮之所以容易发酵，是因为它满足了观众对「幕后」的好奇，同时也容易被过度解读。',
          '从目前的讨论走向看，话题仍停留在对拍摄状态的围观层面，尚未涉及内容评价。后续官方物料是否回应，会决定这波热度能不能延续。',
        ],
      },
    ],
  },
  {
    id: 'chunshan-yinyuejie-wanchang',
    title: '音乐节压轴返场三首，万人合唱画面冲上热搜',
    summary:
      '春山音乐节收官夜，压轴嘉宾临时加唱三首，全场大合唱的灯海画面被刷屏，成为当晚讨论度最高的一幕。',
    category: '音乐现场',
    author: '现场小分队',
    date: '2026-09-10',
    readMinutes: 3,
    heat: 9140,
    cover:
      'https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20at%20dusk%20with%20warm%20orange%20stage%20lights%20and%20a%20sea%20of%20phone%20flashlights%2C%20crowd%20silhouettes%2C%20stylized%20painterly%20illustration%2C%20cinematic%20atmosphere%2C%20no%20readable%20text&width=1200&height=800&seq=gualiao-music-01&orientation=landscape',
    tags: ['春山音乐节', '压轴返场', '大合唱'],
    content: [
      {
        heading: '返场三首，现场情绪拉满',
        paragraphs: [
          '按原定流程，压轴环节应在两首歌后收尾。但现场观众持续合唱，嘉宾临时决定返场，加唱了三首老歌，其中一首是多年未在音乐节舞台出现过的曲目。',
          '返场期间全场的手机灯海被多个机位拍下，短视频在夜间快速传播，「春山音乐节返场」也随之进入热搜讨论区。',
        ],
      },
      {
        heading: '讨论集中在两点',
        paragraphs: [
          '第一是现场体验，不少到场观众表示这是整晚情绪最高的一段，临时加歌让行程更有记忆点。',
          '第二是秩序问题，也有网友提到返场时间较晚，散场交通压力增大，希望后续场次能提前做好疏导安排。',
        ],
      },
    ],
  },
  {
    id: 'zongyi-luzhao-kandian',
    title: '综艺录制路透刷屏，嘉宾临场发挥成最大看点',
    summary:
      '新一季综艺首期录制路透流出，一段没有台本的临场互动被剪成多个版本传播，网友直呼「比正片还好看」。',
    category: '综艺录制',
    author: '综艺观察',
    date: '2026-09-09',
    readMinutes: 3,
    heat: 8760,
    cover:
      'https://readdy.ai/api/search-image?query=Bright%20colorful%20variety%20show%20studio%20stage%20with%20geometric%20lighting%20panels%2C%20playful%20abstract%20set%20design%2C%20warm%20pink%20and%20gold%20palette%2C%20stylized%20modern%20illustration%2C%20no%20readable%20text&width=1200&height=800&seq=gualiao-show-01&orientation=landscape',
    tags: ['综艺录制', '路透', '临场发挥'],
    content: [
      {
        heading: '一段没台本的互动',
        paragraphs: [
          '路透片段里，嘉宾江野与温屿在等待布景调整时即兴接梗，现场笑声不断。这段不在台本内的互动被观众拍下后，被剪成多个版本在各个平台流传。',
          '节目组暂未对路透内容作出回应，不过从传播量来看，这段临场发挥确实成了首期最大的记忆点。',
        ],
      },
      {
        heading: '路透太多是好事吗',
        paragraphs: [
          '有观众认为路透提升了期待值，也有人担心剧透过多会削弱正片观感。综艺类内容尤其依赖「第一次反应」的新鲜感，过度曝光可能得不偿失。',
          '从平台角度看，路透带来的自然流量确实可观，但如何平衡宣传节奏，仍是节目组需要拿捏的部分。',
        ],
      },
    ],
  },
  {
    id: 'pinpai-lianming-shouqing',
    title: '品牌联名上新三小时售罄，粉丝排队话题同步升温',
    summary:
      '某潮流品牌与影视 IP 的联名系列上午开售，多个热门款三小时内售罄，线下门店排队画面同样被大量讨论。',
    category: '品牌合作',
    author: '消费前线',
    date: '2026-09-09',
    readMinutes: 3,
    heat: 8210,
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20retail%20store%20display%20with%20warm%20gold%20and%20deep%20red%20merchandise%20arrangement%2C%20elegant%20minimal%20shelving%2C%20soft%20studio%20lighting%2C%20editorial%20still%20life%20illustration%2C%20no%20readable%20text&width=1200&height=800&seq=gualiao-brand-01&orientation=landscape',
    tags: ['联名', '售罄', '线下排队'],
    content: [
      {
        heading: '开售即售罄',
        paragraphs: [
          '联名系列共上线十余个单品，其中卫衣与帆布包最先售罄。有网友晒出订单截图称「付款页面卡了十秒」，也有线下门店出现排队情况。',
          '品牌方客服回应称，部分款式会安排补货，具体时间以官方公告为准。',
        ],
      },
      {
        heading: '联名的价值在哪',
        paragraphs: [
          '影视 IP 与潮流品牌的联名已不新鲜，但能否持续，取决于设计是否经得起日常穿着，而不是只靠一次性话题。',
          '这次讨论里，认可设计的声音和吐槽溢价的声音都有，最终还是要看复购数据。',
        ],
      },
    ],
  },
  {
    id: 'fensi-yingyuan-daping',
    title: '粉丝自发应援登上城市大屏，路人直呼排面',
    summary:
      '为庆祝艺人新项目官宣，粉丝团自发组织城市大屏应援，多个商圈点位轮播同一组画面，引发路人围观和讨论。',
    category: '粉丝圈层',
    author: '圈层观察',
    date: '2026-09-08',
    readMinutes: 3,
    heat: 7640,
    cover:
      'https://readdy.ai/api/search-image?query=Night%20city%20street%20with%20large%20glowing%20LED%20billboard%20screens%20in%20warm%20amber%20and%20rose%20tones%2C%20crowd%20looking%20up%2C%20stylized%20urban%20illustration%2C%20cinematic%20bokeh%2C%20no%20readable%20text&width=1200&height=800&seq=gualiao-fans-01&orientation=landscape',
    tags: ['应援', '大屏', '粉丝团'],
    content: [
      {
        heading: '应援是怎么组织的',
        paragraphs: [
          '据参与组织的粉丝介绍，这次大屏应援从策划到落地用了约两周，点位集中在几个客流量较大的商圈，采用轮播形式。',
          '应援画面以温暖色调为主，没有使用夸张标语，更多是祝福性质的内容。',
        ],
      },
      {
        heading: '理性应援成主流讨论',
        paragraphs: [
          '评论区里，「量力而行」是出现频率较高的说法。不少粉丝表示支持公开、透明、不攀比的组织方式。',
          '也有路人表示，路过看到大屏画面确实会停下拍照，这种「城市里偶遇」的体验本身就是传播的一部分。',
        ],
      },
    ],
  },
  {
    id: 'niandu-pingxuan-rumu',
    title: '年度评选入围名单公布，几家欢喜几家讨论',
    summary:
      '年度影视评选入围名单今日公布，多个热门项目同时上榜，也有不少作品落选，围绕评选标准的讨论随之而来。',
    category: '影视现场',
    author: '瓜务组',
    date: '2026-09-08',
    readMinutes: 4,
    heat: 7080,
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20stage%20with%20warm%20gold%20curtain%20and%20soft%20spotlights%2C%20deep%20red%20carpet%20hint%2C%20abstract%20stylized%20illustration%2C%20luxurious%20editorial%20mood%2C%20no%20readable%20text&width=1200&height=800&seq=gualiao-award-01&orientation=landscape',
    tags: ['年度评选', '入围名单', '评选标准'],
    content: [
      {
        heading: '名单看点',
        paragraphs: [
          '入围名单覆盖剧集、综艺、音乐三大板块。几部今年讨论度高的剧集同时出现在多个奖项中，成为最大赢家候选。',
          '与此同时，一些口碑不错但热度一般的作品没有出现在名单里，引发「评选更看热度还是看质量」的讨论。',
        ],
      },
      {
        heading: '围绕标准的争论',
        paragraphs: [
          '有观点认为，大众评选本就兼顾传播度，不必用纯艺术标准苛求；也有观点希望评委会公布更细的评分维度，让结果更有说服力。',
          '无论哪种声音，名单公布本身就完成了一次行业话题的集中释放。',
        ],
      },
    ],
  },
  {
    id: 'xingzhuan-shiting-gongkai',
    title: '新专辑首波试听公开，编曲走向引乐评人热议',
    summary:
      '一张备受期待的新专辑放出首波三十秒试听，编曲从电子转向器乐，乐评人与乐迷对这次转向看法不一。',
    category: '音乐现场',
    author: '耳朵小组',
    date: '2026-09-07',
    readMinutes: 3,
    heat: 6620,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20music%20studio%20scene%20with%20analog%20synthesizers%20and%20warm%20amber%20accent%20lighting%2C%20vinyl%20records%2C%20moody%20minimal%20stylized%20illustration%2C%20no%20readable%20text&width=1200&height=800&seq=gualiao-album-01&orientation=landscape',
    tags: ['新专辑', '试听', '编曲'],
    content: [
      {
        heading: '三十秒能听出什么',
        paragraphs: [
          '首波试听只有三十秒，但器乐比例明显提升，弦乐与合成器叠加的方式和上一张专辑差别不小。',
          '试听放出后，相关话题词条很快出现在讨论区，乐迷把这段音频做了多轮拆解。',
        ],
      },
      {
        heading: '两种解读',
        paragraphs: [
          '一种认为这是团队主动求变，愿意在商业成绩稳定的阶段做更冒险的尝试；另一种担心器乐化会削弱传唱度。',
          '正式全曲上线前，这些讨论都还只是推测，最终还是要交给作品本身。',
        ],
      },
    ],
  },
  {
    id: 'juji-shouguan-jieju',
    title: '剧集收官夜讨论量破表，结局走向意见两极',
    summary:
      '一部追了整个夏天的剧集在昨晚收官，结局处理方式让讨论区直接分成两派，相关词条在深夜仍在攀升。',
    category: '影视现场',
    author: '剧评别动队',
    date: '2026-09-07',
    readMinutes: 4,
    heat: 6310,
    cover:
      'https://readdy.ai/api/search-image?query=Empty%20cinema%20screen%20glowing%20with%20warm%20amber%20light%20in%20a%20dark%20theater%2C%20red%20seats%2C%20cinematic%20minimal%20stylized%20illustration%2C%20no%20readable%20text&width=1200&height=800&seq=gualiao-drama-01&orientation=landscape',
    tags: ['收官', '结局', '剧评'],
    content: [
      {
        heading: '结局怎么引爆讨论的',
        paragraphs: [
          '收官集采用开放式收尾，主线留下了一段没有明确交代的空白。部分观众觉得余味悠长，另一部分观众认为铺垫了三十集却没有回应，情绪上难以接受。',
          '播出后两小时内，相关词条在多个平台同时上升，深夜时段仍是讨论高峰。',
        ],
      },
      {
        heading: '开放式结局的老问题',
        paragraphs: [
          '开放式结局天然容易两极分化，它把解读权交给观众，同时也把「不满足感」留给了期待明确答案的人。',
          '从创作角度说，主创的选择有其逻辑；从观众角度说，情绪反弹也很真实。这本身就是长剧集常见的收官现象。',
        ],
      },
    ],
  },
  {
    id: 'zhibo-lianxian-jiuchang',
    title: '直播连线突发状况，主持人救场被夸高情商',
    summary:
      '一场直播连线中嘉宾连线中断，主持人临时用一段互动填补空档，处理方式被网友截图讨论，登上今日热议。',
    category: '综艺录制',
    author: '综艺观察',
    date: '2026-09-06',
    readMinutes: 3,
    heat: 5740,
    cover:
      'https://readdy.ai/api/search-image?query=Live%20broadcast%20studio%20with%20warm%20amber%20and%20rose%20lighting%2C%20abstract%20microphone%20and%20camera%20shapes%2C%20stylized%20minimal%20illustration%2C%20no%20readable%20text&width=1200&height=800&seq=gualiao-live-01&orientation=landscape',
    tags: ['直播', '救场', '主持人'],
    content: [
      {
        heading: '意外发生的三十秒',
        paragraphs: [
          '连线环节进行到一半，嘉宾一侧网络中断，画面卡住。主持人没有停顿，顺势抛出一个轻松的问题给现场嘉宾，把节奏接了过去。',
          '这三十秒被观众录屏后传播，评论区普遍认为处理得自然，没有让冷场明显暴露出来。',
        ],
      },
      {
        heading: '为什么会成为话题',
        paragraphs: [
          '直播的临场感正是它的魅力，观众对「真实反应」的偏好，让一次救场也能成为当天的讨论素材。',
          '需要说明的是，这类片段的传播更多是围观性质，不必过度拔高。',
        ],
      },
    ],
  },
];

export const getArticleById = (id: string) => articles.find((item) => item.id === id);